exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-link[data-v-2d173780] {\n  position: relative;\n}\n.new-link[data-v-2d173780]:after {\n  content: \"\";\n  width: 35px;\n  height: 35px;\n  background-image: url(\"/front/img/illustration/new_badge.svg\");\n  position: absolute;\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin-right: 15px;\n}\n@media screen and (max-width: 640px) {\n.new-link[data-v-2d173780]:after {\n    content: \"\";\n    width: 22px;\n    height: 22px;\n}\n}", ""]);

// exports
